import { useState } from "react";
import AdminTokensService from "./AdminTokensService";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";

export default function AdminRefreshTokensPage() {
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFetch = async () => {
    if (!userId && !email) return;
    setLoading(true);
    try {
      const res = userId ? await AdminTokensService.listTokensByUser(userId) : await AdminTokensService.listTokensByEmail(email);
      setTokens(res.data || []);
    } catch (e) {
      toast.error("Impossible de charger les tokens");
    } finally {
      setLoading(false);
    }
  };

  const handleRevoke = async () => {
    if (!userId && !email) return;
    setLoading(true);
    try {
      if (userId) {
        await AdminTokensService.revokeTokensByUser(userId);
      } else {
        await AdminTokensService.revokeTokensByEmail(email);
      }
      toast.success("Tokens révoqués");
      await handleFetch();
    } catch (e) {
      toast.error("Révocation échouée");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <Card className="border-0 shadow">
        <CardHeader>
          <CardTitle>Admin • Refresh Tokens</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-2 mb-4">
            <div className="flex gap-2">
              <Input type="number" placeholder="User ID" value={userId} onChange={(e) => setUserId(e.target.value)} />
              <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="flex gap-2">
              <Button onClick={handleFetch} disabled={loading || (!userId && !email)}>Charger</Button>
              <Button variant="destructive" onClick={handleRevoke} disabled={loading || (!userId && !email)}>Révoquer tous</Button>
            </div>
          </div>
          <div className="space-y-2">
            {tokens.length === 0 ? (
              <div className="text-sm text-muted-foreground">Aucun token</div>
            ) : (
              tokens.map((t) => (
                <div key={t.id} className="text-sm p-3 border rounded-md flex justify-between">
                  <span>#{t.id} • créé: {new Date(t.created_at).toLocaleString()} • expire: {new Date(t.expires_at).toLocaleString()}</span>
                  <span className={t.revoked ? "text-red-500" : "text-green-600"}>{t.revoked ? "Révoqué" : "Actif"}</span>
                </div>
              ))
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}


